module.exports = __webpack_public_path__ + "img/Infografis_EN_16.a1237d1b.jpg";